import React, { MouseEvent } from 'react';
import {
    Stack,
    PrimaryButton,
    DefaultButton,
    BaseButton,
    Button,
} from '@fluentui/react';
import { BaseSyntheticEvent } from 'react';
import { appStyles } from '../../helpers';
import { useAppSelector, useAppDispatch } from '../../store';
import { renameFileThunk } from '../../store/actions/app/thunks';
import { selectTranslate } from '../../store/selectors/ui';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { ControlledTextField } from './controls/controlledTextField';
import * as path from 'path';
import { editFilenameFormDataSchema } from '../../schemas/editFilename';
import { RenameFileData } from '../../model';

type Props = {
    initialPath: string;
    onCancel: (
        event?: MouseEvent<HTMLElement | BaseButton | Button> | null,
    ) => void;
};

export const EditFilenameForm = ({ initialPath, onCancel }: Props) => {
    const translate = useAppSelector(selectTranslate);
    const { handleSubmit, register, control } = useForm<RenameFileData>({
        defaultValues: async () => {
            return {
                initialPath,
                newFilename: path.parse(initialPath).name,
            };
        },
        resolver: zodResolver(editFilenameFormDataSchema),
        mode: 'onSubmit',
    });

    const dispatch = useAppDispatch();
    const onSubmitHandler = (data: RenameFileData, _e?: BaseSyntheticEvent) => {
        onCancel(null);
        dispatch(renameFileThunk(data));
    };

    return (
        <form onSubmit={handleSubmit(onSubmitHandler)}>
            <Stack tokens={{ childrenGap: '1rem' }}>
                <ControlledTextField
                    control={control}
                    {...register('newFilename')}
                    label={translate('enter_name')}
                />
                <Stack
                    horizontal={true}
                    horizontalAlign="end"
                    tokens={{ childrenGap: '1rem' }}
                >
                    <DefaultButton
                        styles={appStyles.primaryButtonReverse}
                        onClick={onCancel}
                    >
                        {translate('button_cancel')}
                    </DefaultButton>
                    <PrimaryButton
                        type="submit"
                        styles={appStyles.primaryButton}
                    >
                        {translate('save')}
                    </PrimaryButton>
                </Stack>
            </Stack>
        </form>
    );
};
